export default __webpack_public_path__ + "static/media/logoMICROSOFT_2.fd3d13d8.png";